import * as React from 'react';
import { __ } from 'react-i18n/lib';
import styled from 'styled-components';
import { rem } from 'polished';
import { ButtonStyled } from '../_helpers/form/Button';
import { Container } from '../../theme/libraries/grid';
import EmailAutocomplete from '../_helpers/form/EmailAutocomplete';
import { Loader } from '../_helpers/Loader/Loader';

const border =
  'data:image/svg+xml;base64,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';

const Background = styled.div`
  background: rgb(211, 229, 247)};
  position: relative;
  padding: ${rem(20)} 0;
  z-index: 1;
  &:before,
  &:after {
    display: block;
    content: '';
    width: 100%;
    position: absolute;
    left: 0;
  }
  &:before {
    background: top url(${border}) repeat-x;
    height: ${rem(15)};
    top: ${rem(-9)};
    z-index: 1;
    filter: invert(11%) sepia(13%) saturate(335%) hue-rotate(173deg) brightness(99%) contrast(95%);
  }
`;

const ContainerNewsletter = styled(Container)`
  display: flex;
  align-items: center;
`;

const Col = styled.div`
  flex: 0 0 ${({ theme }) => theme.grid.col.col6};
  &.left {
    flex: 0 0 45%;
  }
  &.right {
    flex: 0 0 55%;
  }
  &:first-child {
    padding-left: ${rem(20)};
    padding-right: ${rem(40)};
  }
  &:last-child {
    padding-right: ${rem(20)};
  }
  &.school.left,
  &.school.right {
    flex: 0 0 50%;
  }
`;

const Title = styled.p`
  font-size: ${rem(24)};
  font-weight: 800;
  margin: 0;
`;

const Description = styled.p`
  font-size: ${rem(16)};
  margin: 0;
`;

const Form = styled.form`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: ${({ theme }) => theme.boxShadow.small};
  ${({ theme }) => theme.media('xs')} {
    display: flex;
    align-items: stretch;
  }
`;

const NewsletterInput = styled(EmailAutocomplete)`
  display: block;
  flex: 1 0 auto;
  border-color: transparent;
  width: 100%;
  padding: ${rem(15)};
  margin-right: ${({ theme }) => rem(-theme.form.border.width)};
  ${({ theme }) => theme.media('xs')} {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
`;

const NewsletterSubmit = styled(ButtonStyled)`
  display: block;
  flex: 0 0 auto;
  width: 100%;
  padding: ${rem(14)} ${rem(14)} ${rem(10)};
  ${({ theme }) => theme.media('xs')} {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    width: auto;
    padding: ${rem(15)} ${rem(20)};
    margin-top: 0;
  }
`;

const GDPR = styled.p`
  font-size: ${rem(13)};
  a {
    color: ${({ theme }) => theme.color.black};
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;

const Validation = styled.p`
  color: ${({ theme }) => theme.color.error};
`;

const Success = styled.p`
  color: ${({ theme }) => theme.color.success};
`;

export enum NewsletterType {
  BASE,
  SCHOOL,
}

interface Props {
  loader: boolean;
  response: boolean | null;
  onSubmit: (e: any) => void;
  type?: NewsletterType;
}

interface States {
  email: string;
}

class Newsletter extends React.PureComponent<Props, States> {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  public handleInput = (e) => {
    this.setState({ email: e.target.value });
  };

  public render() {
    const { loader, response, onSubmit, type } = this.props;
    const { email } = this.state;

    const isSchoolType = type === NewsletterType.SCHOOL;

    return (
      <Loader loading={loader}>
        <Background>
          <ContainerNewsletter className="base">
            {isSchoolType ? (
              <Col className={'left school'}>
                <Title>{__('Novinky emailom pre školy a učiteľov')}</Title>
                <Description>
                  {__(
                    'Prihláste sa k odberu noviniek a akcií určených pre školské zariadenia a pedagógov. Zo zasielania sa môžete kedykoľvek odhlásiť.',
                  )}
                </Description>
              </Col>
            ) : (
              <Col className={'left'}>
                <Title>{__('Výhodné ponuky emailom')}</Title>
                <Description>
                  {__('Prihláste sa do newslettra a získajte pravidelné')}
                  <strong>
                    {' '}
                    {__('informácie o super ponukách, akciách a zľavách.')}
                  </strong>{' '}
                  {__('Zo zasielania sa môžete kedykoľvek odhlásiť.')}
                </Description>
              </Col>
            )}

            <Col className={`right ${isSchoolType ? 'school' : ''}`}>
              {response !== null ? (
                response ? (
                  <Success>
                    {__('Boli ste úspešne prihlásený do newslettra')}
                  </Success>
                ) : (
                  <Validation>
                    {__(
                      'Tvar zadaného emailu nie je správny. Skontrolujte ho, prosím.',
                    )}
                  </Validation>
                )
              ) : (
                ''
              )}

              <Form onSubmit={onSubmit}>
                <NewsletterInput
                  name="email"
                  placeholder={__('Zadajte váš email')}
                  value={email}
                  onChange={this.handleInput}
                />
                <NewsletterSubmit type="submit" className="primary">
                  {__('Prihlásiť')}
                </NewsletterSubmit>
              </Form>
              <GDPR>
                {__(
                  'Vložením a odoslaním e-mailovej adresy prostredníctvom červeného tlačidla „Prihlásiť“ súhlasíte so zasielaním informačných e-mailov na túto adresu a',
                )}{' '}
                <a href={'/gdpr'} target="_blank">
                  {__('spracovaním Vašich osobných údajov')}
                </a>{' '}
                {__(
                  'pre tento účel. Informačné e-maily sú určené pre osoby staršie ako 16 rokov!',
                )}
              </GDPR>
            </Col>
          </ContainerNewsletter>
        </Background>
      </Loader>
    );
  }
}

export default Newsletter;
